import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { iconAttributes } from '@/utils/icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'Sync',
  setup(__props) {

const attrs = iconAttributes({ width: 16, height: 22 });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _normalizeProps(_guardReactiveProps(_unref(attrs))), _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.00977 3V0L4.00977 4L8.00977 8V5C11.3198 5 14.0098 7.69 14.0098 11C14.0098 12.01 13.7598 12.97 13.3098 13.8L14.7698 15.26C15.58 13.9869 16.0102 12.5091 16.0098 11C16.0098 6.58 12.4298 3 8.00977 3ZM8.00977 17C4.69977 17 2.00977 14.31 2.00977 11C2.00977 9.99 2.25977 9.03 2.70977 8.2L1.24977 6.74C0.439518 8.01309 0.00934601 9.49094 0.00976593 11C0.00976593 15.42 3.58977 19 8.00977 19V22L12.0098 18L8.00977 14V17Z",
      fill: "currentColor"
    }, null, -1)
  ]), 16))
}
}

})